<template>
	<div class="loading">
		<div class="col-12">
			<p class="text-center">
				<i class="fas fa-spinner fa-spin"></i>
				{{ message }}
			</p>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		message: {
			type: String,
			required: false,
			default: 'Loading...'
		}
	},
}
</script>
